import { Packr } from 'msgpackr'

const packr = new Packr({ structuredClone: true })

export function writePacket(data) {
  const packet = packr.pack(data)
  return packet
}

export function readPacket(packet) {
  const data = packr.unpack(packet)
  return data
}
